export default "__VITE_ASSET__ec9053e4__"